class CartService {
    constructor(){
        this.baseUrl = window.Shopify?.routes?.root || '/';
    }

    static instance = null;

    static getInstance() {
        if (!CartService.instance) {
            CartService.instance = new CartService();
        }
        return CartService.instance;
    }

    async getCart(handle) {
        try {
            // const baseUrl = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${this.baseUrl}cart.js`);
            
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            
            const product = await response.json();
            return product; // Let the caller handle the data
        } catch (e) {
            console.error(`Failed to fetch product ${handle}:`, e);
            return null;
        }
    }

    async updateCart(items){
        try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            });
            
            const result = await response.json();
            return result;
            // window.location.href = '/cart';
          } catch (error) {
            console.error('Erro:', error);
            return null;
          }
    }
}